<app-featuress 
bgImage="why.png"
  logoLeft="lo.webp"
  logoRight="lo-1.webp"
  bannerText="একই আস্থা, নতুন সম্ভাবনা | নেটিজেন এখন লিডসইউন"
></app-featuress>

<app-about-us></app-about-us>
<app-school-mangment-video></app-school-mangment-video>
<app-why-eduman-is-the-trusted-choice></app-why-eduman-is-the-trusted-choice>
<app-cards></app-cards>
<app-money-back-slider></app-money-back-slider>